import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import {PreventiveMaintenanceAssignFormService} from '../preventive-maintenance-assign-form';
import { PreventiveMaintenanceDetailService } from './preventive-maintenance-detail.service';
import { PreventiveMaintenanceEquipmentSummaryService } from './preventive-maintenance-equipment-summary.service';
import { PreventiveMaintenanceChangeLogService } from './preventive-maintenance-change-log.service';
import { PreventiveMaintenanceCancelService } from './preventive-maintenance-cancel.service';

import { PMStatus } from './../../../../model';

import { saveAs } from 'file-saver';
import * as $ from 'jquery';
import { Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  selector: 'app-preventive-maintenance-detail',
  templateUrl: './preventive-maintenance-detail.component.html',
  styleUrls: ['./preventive-maintenance-detail.component.css'],
})
export class PreventiveMaintenanceDetailComponent implements OnInit {

  @ViewChild('warningModal') warningModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  isDownloading = false;

  pmId = '';
  pm: any;
  pmStatus = PMStatus;

  equipments: any[];
  changeLogs: any[];
  equipmentDataTable: any;
  changeLogDataTable: any;

  isReset = false ;

  constructor(
    private assignFormService: PreventiveMaintenanceAssignFormService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private pmDetailService: PreventiveMaintenanceDetailService,
    private pmEquipmentSummaryService: PreventiveMaintenanceEquipmentSummaryService,
    private pmChangeLogService: PreventiveMaintenanceChangeLogService,
    private pmCancelService: PreventiveMaintenanceCancelService,
    private chRef: ChangeDetectorRef,
    ) {
      this.route.params.subscribe(params => { this.pmId = params['id']; });
      this.translate.setDefaultLang('en-us');
    }

  ngOnInit() {

            this.pmDetailService.getDetail(this.pmId).subscribe( (data) => {
                    this.pm = data;
                    this.chRef.detectChanges();

                    this.pmEquipmentSummaryService.getSummary(this.pmId).subscribe( (data) => {
                      if ($.fn.dataTable.isDataTable('#equipmentDataTables')) { $('#equipmentDataTables').DataTable().destroy(); }

                      this.equipments = data.pmequipmentListModel;
                      this.chRef.detectChanges();

                      const table: any = $('#equipmentDataTables');
                      this.equipmentDataTable = table.DataTable();

                    },
                    error => {
                      this.exception.showError(error, 'showDanModalBtn');
                      this.redirect = true;
                    });


                    this.pmChangeLogService.getChangeLog(this.pmId).subscribe( (data) => {
                      if ($.fn.dataTable.isDataTable('#changeLogDataTables')) { $('#changeLogDataTables').DataTable().destroy(); }

                      this.changeLogs = data.pmchangeLogListModel;
                      this.chRef.detectChanges();

                      const table: any = $('#changeLogDataTables');
                      this.changeLogDataTable = table.DataTable({
                         "ordering": false,
                      });

                    },
                    error => {
                      this.exception.showError(error, 'showDanModalBtn');
                      this.redirect = true;
                    });


                },
                error => {
                  this.pm = {};
                  this.chRef.detectChanges();
                  $('.card').hide();
                  this.exception.showError(error, 'showDanModalBtn');
                  this.redirect = true;
                }
            );


  }

  downloadForm(formId, isSpecial, pmId, eqDetailId) {
    this.isDownloading = true;
    this.assignFormService.getForm(formId, isSpecial, pmId, eqDetailId ).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  downloadCoverSheet(coverSheet) {
    this.isDownloading = true;

    this.pmDetailService.getCoverSheet(coverSheet).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;

    });
  }
  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/preventive-maintenance']);
    }
    else {
      this.dangerModal.hide();
    }
  }

  cancelPopUp() {
    this.dialog.showModal('showWarnModalBtn');
  }

  cancel() {
    this.warningModal.hide();

    this.pmCancelService.cancel(this.pmId).subscribe(data => {

      this.dialog.showModal('showSucModalBtn');
      this.pm = null;
      // this.chRef.detectChanges();
      // this.router.navigate([this.router.url]);
      this.ngOnInit();
    },
    error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });

  }






}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-detail/preventive-maintenance-detail.component.ts